export const upcomingevents = [
  {
    id: 1,
    title: "Afrostalgia",
    date: "28/12/2024",
    time: "9pm - 3am",
    address: "Jungle Bar and Grill, 133 Stockwell Road, London, SW9 9TN",
    price: "£10-£30",
    image:
      "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page/landing/afrostalgia.webp",
    link: "https://www.eventbrite.co.uk/e/afrostalgia-tickets-1085292672599?aff=oddtdtcreator",
  },

  {
    id: 2,
    title: "AfroSounds",
    date: "31/08/2024",
    time: "11pm - 4am",
    address: "The Lower Third, 26 Denmark Street, London, WC2H 8NJ",
    price: "£15",
    image:
      "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page/landing/afrosounds.webp",
    link: "",
  },

  {
    id: 3,
    title: "The AfroCollective Experience",
    date: "19/07/2024",
    time: "11pm - 4am",
    address: "Vauxhall Arches, 39 Parry Street, London, SW6 1RT",
    price: "£15+",
    image:
      "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page/landing/taceupc.webp",
    link: "",
  },

  {
    id: 4,
    title: "Introducing Summer Florida",
    date: "31/05/2025",
    time: "3pm - 11pm",
    address: "91-92 Great Eastern St, London EC2A 3HZ",
    price: "£10+",
    image:
      "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page/landing/introsumupc.webp",
    link: "https://www.eventbrite.co.uk/e/introducing-summer-afrocollective-x-gle-tickets-1312781728489?aff=oddtdtcreator",
  },
  {
    id: 5,
    title: "The Off Season",
    date: "07/09/2025",
    time: "3pm",
    address: "Brixton Jamm 261 Brixton Road SW9 6LH",
    price: "£6.50+",
    image:
      "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page/landing/offseasonbg.webp",
    link: "https://dice.fm/partner/ac-tiktok/event/xep833-the-offseason-7th-sep-brixton-jamm-london-tickets?dice_id=6672335&dice_channel=tiktok&dice_tags=organic&dice_campaign=Ac+Tiktok&dice_feature=mio_marketing&utm_source=tiktok&utm_campaign=Ac+Tiktok&utm_medium=mio_marketing&_branch_referrer=H4sIAAAAAAAAAwXBSQ6CMBQA0Nu4UwYNqAkxiDghBhITtJumpZ9SkKmgWBee3ffyYWj7taY9RV3OmEhhllXa12KLuUEZAIFNRtOnYE7konuuU37NUaJ74c13XZLtKNraIIrr24zNy1xFh%2BDl1%2BoMW8SxgT9n0%2B5K2anXm0ODOW%2BjYp%2BoYHUkIyZQ4TAerAfDqRmgZrpUHinbUI2Tn4QMpBQ1x1Q2Yw%2FSOdX9QLgk1R9MzPd%2FsQAAAA%3D%3D&_branch_match_id=1478326040979704287",
  },
];
